module.exports = __webpack_public_path__ + "cdcd7842657eb5ca6875c64554231367.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-76.png
// module id = 144
// module chunks = 0